<template>
  <div>
    <vs-input
        v-validate="'required|email|min:3'"
        data-vv-validate-on="blur"
        name="email"
        icon-no-border
        icon="icon icon-user"
        icon-pack="feather"
        label-placeholder="Email"
        v-model="email"
        class="w-full mt-5 pt-5"/>
    <span class="text-danger text-sm">{{ errors.first('email') }}</span>

    <vs-input
        data-vv-validate-on="blur"
        v-validate="'required|min:5|max:10'"
        type="password"
        name="password"
        icon-no-border
        icon="icon icon-lock"
        icon-pack="feather"
        label-placeholder="Password"
        v-model="password"
        class="w-full mt-5 pt-5"
        @keydown="keyDown"
    />
    <span class="text-danger text-sm">{{ errors.first('password') }}</span>

    <div class="flex flex-wrap justify-between my-5">
        <!-- <vs-checkbox v-model="checkbox_remember_me" class="mb-3">Remember Me</vs-checkbox>
        <router-link to="/pages/forgot-password">Forgot Password?</router-link> -->
    </div>
    <div class="flex flex-wrap justify-between mb-3">
      <!-- <vs-button  type="border" @click="registerUser">Register</vs-button> -->
      <vs-button :disabled="!validateForm" @click="loginJWT">Login</vs-button>
    </div>
  </div>
</template>

<script>
import { serverError, showErrors } from '../../../utils/errorsUtils'

export default {
  data () {
    return {
      email: '',
      password: '',
      checkbox_remember_me: false
    }
  },
  computed: {
    validateForm () {
      return !this.errors.any() && this.email !== '' && this.password !== ''
    }
  },
  methods: {
    keyDown (event) {
      if (!this.validateForm) {
        return
      }
      if (event.key == 'Enter') {
        this.loginJWT()
      }
    },
    async loginJWT () {

      this.$vs.loading()
      const payload = {
        email: this.email,
        password: this.password
      }
      // console.log(payload)
      try {
        const result = await this.$store.dispatch('loginManagement/loginWithEmail', payload)
        // console.log('login result', result)
        if (!result.isSuccess) {
          showErrors(this, result.errors)
        } else {
          localStorage.setItem('token', result.body.token)
          localStorage.setItem('isLogin', true)
          this.$vs.notify({
            title: '',
            text: 'Login Successful',
            color: 'success'
          })
          // push user to expected path
          if (this.$route.query.to) {
            this.$router.push(this.$route.query.to)
          } else {
            this.$router.push('/dashboard/analytics')
          }
        }
        this.$vs.loading.close()
      } catch (err) {
        console.debug(err)
        serverError(this)
        this.$vs.loading.close()
      }
    }
  }
}

</script>

